import { tm } from '../tm'
import type { Project } from '@captaincause/types'
import type { CSSProperties } from 'react'

interface ProjectOrganizationLogoProps {
  project: Project
  className?: string
  style?: CSSProperties
  showOrganizationInfos?: boolean
}

const emptyObject = {}
export function ProjectOrganizationLogo({
  project,
  className = '',
  style = emptyObject,
  showOrganizationInfos = true,
}: ProjectOrganizationLogoProps) {
  return (
    <div className={tm('flex items-center', className)} style={style}>
      {project.organization.logo ? (
        <div className="flex h-12 max-h-[64px] w-12 max-w-[64px] items-center justify-center overflow-hidden rounded-lg">
          <img
            src={project.organization.logo}
            alt={`${project.organization.name} logo`}
            className="h-full w-full object-contain"
          />
        </div>
      ) : null}
      {showOrganizationInfos ? (
        <span className="ml-2 h-fit font-medium">
          {project.organization.name}
        </span>
      ) : null}
    </div>
  )
}
